import React, { useState } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

function DoubleImageViewer({ closeupImages, showPopup = true, t }) {
  const [show, setShow] = useState(false);

  const openOverlay = () => {
    setShow(true);
  };

  const ImageView = () => (
    <div className="image-viewer">
      {closeupImages && (
        <img
          className="thumbnail"
          src={closeupImages[0].url}
          alt="img"
          width="100%"
          height="100%"
        />
      )}

      {!show && (
        <div onClick={openOverlay} className="overlay">
          <span className="view-button">{t("image.view")}</span>
        </div>
      )}
    </div>
  );

  return (
    <>
      {ImageView()}
      {/* {show && <ImageOverlay />} */}
    </>
  );
}

function mapStateToProps(state) {
  return {};
}

export default connect(
  mapStateToProps,
  {},
)(withTranslation()(DoubleImageViewer));
